export const SNUH_DOCTORS = [
  {
    i: "snuh-0001",
    hid: "snuh",
    n: "김영태",
    de: "흉부외과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "snuh-0002",
    hid: "snuh",
    n: "김경환",
    de: "흉부외과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "snuh-0003",
    hid: "snuh",
    n: "강창현",
    de: "흉부외과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "snuh-0004",
    hid: "snuh",
    n: "박인규",
    de: "흉부외과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "snuh-0005",
    hid: "snuh",
    n: "이현주",
    de: "흉부외과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "snuh-0006",
    hid: "snuh",
    n: "백선하",
    de: "신경외과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "snuh-0007",
    hid: "snuh",
    n: "정현태",
    de: "신경외과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "snuh-0008",
    hid: "snuh",
    n: "김정은",
    de: "신경외과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "snuh-0009",
    hid: "snuh",
    n: "강현승",
    de: "신경외과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "snuh-0010",
    hid: "snuh",
    n: "박철기",
    de: "신경외과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "snuh-0011",
    hid: "snuh",
    n: "조태준",
    de: "정형외과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "snuh-0012",
    hid: "snuh",
    n: "장봉순",
    de: "정형외과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "snuh-0013",
    hid: "snuh",
    n: "김한수",
    de: "정형외과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "snuh-0014",
    hid: "snuh",
    n: "이영호",
    de: "정형외과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "snuh-0015",
    hid: "snuh",
    n: "유정준",
    de: "정형외과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "snuh-0016",
    hid: "snuh",
    n: "장학",
    de: "성형외과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "snuh-0017",
    hid: "snuh",
    n: "진웅식",
    de: "성형외과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "snuh-0018",
    hid: "snuh",
    n: "김병준",
    de: "성형외과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "snuh-0019",
    hid: "snuh",
    n: "김상화",
    de: "성형외과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "snuh-0020",
    hid: "snuh",
    n: "정지혁",
    de: "성형외과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "snuh-0021",
    hid: "snuh",
    n: "김재원",
    de: "산부인과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "snuh-0022",
    hid: "snuh",
    n: "박중신",
    de: "산부인과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "snuh-0023",
    hid: "snuh",
    n: "구승엽",
    de: "산부인과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "snuh-0024",
    hid: "snuh",
    n: "정현훈",
    de: "산부인과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "snuh-0025",
    hid: "snuh",
    n: "박찬욱",
    de: "산부인과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "snuh-0026",
    hid: "snuh",
    n: "서대헌",
    de: "피부과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "snuh-0027",
    hid: "snuh",
    n: "권오상",
    de: "피부과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "snuh-0028",
    hid: "snuh",
    n: "조성진",
    de: "피부과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "snuh-0029",
    hid: "snuh",
    n: "이동훈",
    de: "피부과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "snuh-0030",
    hid: "snuh",
    n: "문제호",
    de: "피부과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "snuh-0031",
    hid: "snuh",
    n: "김수웅",
    de: "비뇨의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "snuh-0032",
    hid: "snuh",
    n: "오승준",
    de: "비뇨의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "snuh-0033",
    hid: "snuh",
    n: "곽철",
    de: "비뇨의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "snuh-0034",
    hid: "snuh",
    n: "구자현",
    de: "비뇨의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "snuh-0035",
    hid: "snuh",
    n: "정창욱",
    de: "비뇨의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "snuh-0036",
    hid: "snuh",
    n: "곽상인",
    de: "안과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "snuh-0037",
    hid: "snuh",
    n: "박기호",
    de: "안과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "snuh-0038",
    hid: "snuh",
    n: "박규형",
    de: "안과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "snuh-0039",
    hid: "snuh",
    n: "김성준",
    de: "안과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "snuh-0040",
    hid: "snuh",
    n: "김미금",
    de: "안과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "snuh-0041",
    hid: "snuh",
    n: "이준호",
    de: "이비인후과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "snuh-0042",
    hid: "snuh",
    n: "김동영",
    de: "이비인후과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "snuh-0043",
    hid: "snuh",
    n: "안순현",
    de: "이비인후과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "snuh-0044",
    hid: "snuh",
    n: "김현직",
    de: "이비인후과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "snuh-0045",
    hid: "snuh",
    n: "권성근",
    de: "이비인후과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "snuh-0046",
    hid: "snuh",
    n: "강웅구",
    de: "정신건강의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "snuh-0047",
    hid: "snuh",
    n: "안용민",
    de: "정신건강의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "snuh-0048",
    hid: "snuh",
    n: "이동영",
    de: "정신건강의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "snuh-0049",
    hid: "snuh",
    n: "함봉진",
    de: "정신건강의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "snuh-0050",
    hid: "snuh",
    n: "이유진",
    de: "정신건강의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "snuh-0051",
    hid: "snuh",
    n: "이상건",
    de: "신경과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "snuh-0052",
    hid: "snuh",
    n: "김만호",
    de: "신경과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "snuh-0053",
    hid: "snuh",
    n: "성정준",
    de: "신경과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "snuh-0054",
    hid: "snuh",
    n: "정기영",
    de: "신경과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "snuh-0055",
    hid: "snuh",
    n: "이승훈",
    de: "신경과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "snuh-0056",
    hid: "snuh",
    n: "전윤석",
    de: "마취통증의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "snuh-0057",
    hid: "snuh",
    n: "박재현",
    de: "마취통증의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "snuh-0058",
    hid: "snuh",
    n: "임영진",
    de: "마취통증의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "snuh-0059",
    hid: "snuh",
    n: "김희수",
    de: "마취통증의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "snuh-0060",
    hid: "snuh",
    n: "박희평",
    de: "마취통증의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "snuh-0061",
    hid: "snuh",
    n: "조비룡",
    de: "가정의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "snuh-0062",
    hid: "snuh",
    n: "윤영호",
    de: "가정의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "snuh-0063",
    hid: "snuh",
    n: "박진호",
    de: "가정의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "snuh-0064",
    hid: "snuh",
    n: "박상민",
    de: "가정의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "snuh-0065",
    hid: "snuh",
    n: "박민선",
    de: "가정의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "snuh-0066",
    hid: "snuh",
    n: "방문석",
    de: "재활의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "snuh-0067",
    hid: "snuh",
    n: "정선근",
    de: "재활의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "snuh-0068",
    hid: "snuh",
    n: "신형익",
    de: "재활의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "snuh-0069",
    hid: "snuh",
    n: "이자호",
    de: "재활의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "snuh-0070",
    hid: "snuh",
    n: "서관식",
    de: "재활의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "snuh-0071",
    hid: "snuh",
    n: "신경환",
    de: "방사선종양학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "snuh-0072",
    hid: "snuh",
    n: "우홍균",
    de: "방사선종양학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "snuh-0073",
    hid: "snuh",
    n: "지의규",
    de: "방사선종양학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "snuh-0074",
    hid: "snuh",
    n: "김학재",
    de: "방사선종양학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "snuh-0075",
    hid: "snuh",
    n: "김진호",
    de: "방사선종양학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "snuh-0076",
    hid: "snuh",
    n: "정두현",
    de: "병리과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "snuh-0077",
    hid: "snuh",
    n: "강경훈",
    de: "병리과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "snuh-0078",
    hid: "snuh",
    n: "고재문",
    de: "병리과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "snuh-0079",
    hid: "snuh",
    n: "고지원",
    de: "병리과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "snuh-0080",
    hid: "snuh",
    n: "곽윤진",
    de: "병리과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "snuh-0081",
    hid: "snuh",
    n: "임재준",
    de: "호흡기내과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "snuh-0082",
    hid: "snuh",
    n: "이상민",
    de: "호흡기내과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "snuh-0083",
    hid: "snuh",
    n: "이창훈",
    de: "호흡기내과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "snuh-0084",
    hid: "snuh",
    n: "박영식",
    de: "호흡기내과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "snuh-0085",
    hid: "snuh",
    n: "이진우",
    de: "호흡기내과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "snuh-0086",
    hid: "snuh",
    n: "최은화",
    de: "소아감염분과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "snuh-0087",
    hid: "snuh",
    n: "윤기욱",
    de: "소아감염분과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "snuh-0088",
    hid: "snuh",
    n: "강다연",
    de: "소아감염분과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "snuh-0089",
    hid: "snuh",
    n: "신충호",
    de: "소아내분비분과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "snuh-0090",
    hid: "snuh",
    n: "이영아",
    de: "소아내분비분과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "snuh-0091",
    hid: "snuh",
    n: "이윤정",
    de: "소아내분비분과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "snuh-0092",
    hid: "snuh",
    n: "최윤수",
    de: "소아내분비분과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "snuh-0093",
    hid: "snuh",
    n: "김성헌",
    de: "소아면역류마티스",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "snuh-0094",
    hid: "snuh",
    n: "고재성",
    de: "소아소화기영양",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "snuh-0095",
    hid: "snuh",
    n: "문진수",
    de: "소아소화기영양",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "snuh-0096",
    hid: "snuh",
    n: "심정옥",
    de: "소아소화기영양",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "snuh-0097",
    hid: "snuh",
    n: "김리아",
    de: "소아소화기영양",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "snuh-0098",
    hid: "snuh",
    n: "채종희",
    de: "소아신경분과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "snuh-0099",
    hid: "snuh",
    n: "임병찬",
    de: "소아신경분과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "snuh-0100",
    hid: "snuh",
    n: "김우중",
    de: "소아신경분과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "snuh-0101",
    hid: "snuh",
    n: "김영호",
    de: "소아신경분과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "snuh-0102",
    hid: "snuh",
    n: "김한석",
    de: "소아신생아분과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "snuh-0103",
    hid: "snuh",
    n: "김이경",
    de: "소아신생아분과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "snuh-0104",
    hid: "snuh",
    n: "신승한",
    de: "소아신생아분과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "snuh-0105",
    hid: "snuh",
    n: "김세현",
    de: "소아신생아분과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "snuh-0106",
    hid: "snuh",
    n: "허주선",
    de: "소아신생아분과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "snuh-0107",
    hid: "snuh",
    n: "강희경",
    de: "소아신장분과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "snuh-0108",
    hid: "snuh",
    n: "안요한",
    de: "소아신장분과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "snuh-0109",
    hid: "snuh",
    n: "최나예",
    de: "소아신장분과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "snuh-0110",
    hid: "snuh",
    n: "배은정",
    de: "소아심장분과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "snuh-0111",
    hid: "snuh",
    n: "김기범",
    de: "소아심장분과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "snuh-0112",
    hid: "snuh",
    n: "이상윤",
    de: "소아심장분과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "snuh-0113",
    hid: "snuh",
    n: "송미경",
    de: "소아심장분과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "snuh-0114",
    hid: "snuh",
    n: "김태정",
    de: "소아심장분과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "snuh-0115",
    hid: "snuh",
    n: "강형진",
    de: "소아혈액종양",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "snuh-0116",
    hid: "snuh",
    n: "홍경택",
    de: "소아혈액종양",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "snuh-0117",
    hid: "snuh",
    n: "최정윤",
    de: "소아혈액종양",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "snuh-0118",
    hid: "snuh",
    n: "김보경",
    de: "소아혈액종양",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "snuh-0119",
    hid: "snuh",
    n: "박현진",
    de: "소아혈액종양",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "snuh-0120",
    hid: "snuh",
    n: "서동인",
    de: "소아호흡알레르기",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "snuh-0121",
    hid: "snuh",
    n: "박지수",
    de: "소아호흡알레르기",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "snuh-0122",
    hid: "snuh",
    n: "김현영",
    de: "소아외과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "snuh-0123",
    hid: "snuh",
    n: "홍석균",
    de: "소아외과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "snuh-0124",
    hid: "snuh",
    n: "윤중기",
    de: "소아외과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "snuh-0125",
    hid: "snuh",
    n: "고다영",
    de: "소아외과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "snuh-0126",
    hid: "snuh",
    n: "황호남",
    de: "소아외과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "snuh-0127",
    hid: "snuh",
    n: "김희수",
    de: "소아마취통증",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "snuh-0128",
    hid: "snuh",
    n: "김진태",
    de: "소아마취통증",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "snuh-0129",
    hid: "snuh",
    n: "이지현",
    de: "소아마취통증",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "snuh-0130",
    hid: "snuh",
    n: "김은희",
    de: "소아마취통증",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "snuh-0131",
    hid: "snuh",
    n: "장영은",
    de: "소아마취통증",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "snuh-0132",
    hid: "snuh",
    n: "박관진",
    de: "소아비뇨기과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "snuh-0133",
    hid: "snuh",
    n: "임영재",
    de: "소아비뇨기과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "snuh-0134",
    hid: "snuh",
    n: "김승기",
    de: "소아신경외과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "snuh-0135",
    hid: "snuh",
    n: "피지훈",
    de: "소아신경외과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "snuh-0136",
    hid: "snuh",
    n: "이지연",
    de: "소아신경외과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "snuh-0137",
    hid: "snuh",
    n: "김주환",
    de: "소아신경외과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "snuh-0138",
    hid: "snuh",
    n: "김태훈",
    de: "소아신경외과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "snuh-0139",
    hid: "snuh",
    n: "곽상인",
    de: "소아안과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "snuh-0140",
    hid: "snuh",
    n: "김성준",
    de: "소아안과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "snuh-0141",
    hid: "snuh",
    n: "김정훈",
    de: "소아안과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "snuh-0142",
    hid: "snuh",
    n: "최혁진",
    de: "소아안과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "snuh-0143",
    hid: "snuh",
    n: "정재호",
    de: "소아안과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "snuh-0144",
    hid: "snuh",
    n: "이준호",
    de: "소아이비인후과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "snuh-0145",
    hid: "snuh",
    n: "김동영",
    de: "소아이비인후과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "snuh-0146",
    hid: "snuh",
    n: "김현직",
    de: "소아이비인후과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "snuh-0147",
    hid: "snuh",
    n: "권성근",
    de: "소아이비인후과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "snuh-0148",
    hid: "snuh",
    n: "박무균",
    de: "소아이비인후과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "snuh-0149",
    hid: "snuh",
    n: "김붕년",
    de: "소아정신과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "snuh-0150",
    hid: "snuh",
    n: "김재원",
    de: "소아정신과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "snuh-0151",
    hid: "snuh",
    n: "홍순범",
    de: "소아정신과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "snuh-0152",
    hid: "snuh",
    n: "윤나래",
    de: "소아정신과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "snuh-0153",
    hid: "snuh",
    n: "조태준",
    de: "소아정형외과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "snuh-0154",
    hid: "snuh",
    n: "김한수",
    de: "소아정형외과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "snuh-0155",
    hid: "snuh",
    n: "송미현",
    de: "소아정형외과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "snuh-0156",
    hid: "snuh",
    n: "김지형",
    de: "소아정형외과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "snuh-0157",
    hid: "snuh",
    n: "김형민",
    de: "소아정형외과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "snuh-0158",
    hid: "snuh",
    n: "김웅한",
    de: "소아흉부외과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "snuh-0159",
    hid: "snuh",
    n: "강창현",
    de: "소아흉부외과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "snuh-0160",
    hid: "snuh",
    n: "박샘이나",
    de: "소아흉부외과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "snuh-0161",
    hid: "snuh",
    n: "조성규",
    de: "소아흉부외과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "snuh-0162",
    hid: "snuh",
    n: "곽재건",
    de: "소아흉부외과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "snuh-0163",
    hid: "snuh",
    n: "방문석",
    de: "소아재활의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "snuh-0164",
    hid: "snuh",
    n: "신형익",
    de: "소아재활의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "snuh-0165",
    hid: "snuh",
    n: "이우형",
    de: "소아재활의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "snuh-0166",
    hid: "snuh",
    n: "현성은",
    de: "소아재활의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "snuh-0167",
    hid: "snuh",
    n: "이민용",
    de: "소아재활의학과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "snuh-0168",
    hid: "snuh",
    n: "윤정환",
    de: "암병원종양내과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "snuh-0169",
    hid: "snuh",
    n: "이광웅",
    de: "암병원종양내과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "snuh-0170",
    hid: "snuh",
    n: "최영록",
    de: "암병원종양내과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "snuh-0171",
    hid: "snuh",
    n: "홍석균",
    de: "암병원종양내과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "snuh-0172",
    hid: "snuh",
    n: "김윤준",
    de: "암병원종양내과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "snuh-0173",
    hid: "snuh",
    n: "조혜성",
    de: "암병원종양내과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "snuh-0174",
    hid: "snuh",
    n: "유수종",
    de: "암병원종양내과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "snuh-0175",
    hid: "snuh",
    n: "홍서영",
    de: "암병원종양내과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "snuh-0176",
    hid: "snuh",
    n: "이정훈",
    de: "암병원종양내과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "snuh-0177",
    hid: "snuh",
    n: "김민경",
    de: "암병원종양내과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "snuh-0178",
    hid: "snuh",
    n: "조은주",
    de: "암병원종양내과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "snuh-0179",
    hid: "snuh",
    n: "이윤빈",
    de: "암병원종양내과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "snuh-0180",
    hid: "snuh",
    n: "허문행",
    de: "암병원종양내과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "snuh-0181",
    hid: "snuh",
    n: "신현재",
    de: "암병원종양내과",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "snuh-0182",
    hid: "snuh",
    n: "장학",
    de: "유방센터",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "snuh-0183",
    hid: "snuh",
    n: "진웅식",
    de: "유방센터",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "snuh-0184",
    hid: "snuh",
    n: "김홍규",
    de: "유방센터",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "snuh-0185",
    hid: "snuh",
    n: "문형곤",
    de: "유방센터",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "snuh-0186",
    hid: "snuh",
    n: "이한별",
    de: "유방센터",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "snuh-0187",
    hid: "snuh",
    n: "한원식",
    de: "유방센터",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "snuh-0188",
    hid: "snuh",
    n: "강은혜",
    de: "유방센터",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
  {
    i: "snuh-0189",
    hid: "snuh",
    n: "이창훈",
    de: "유방센터",
    s: [],
    recs: { dr: 0, nr: 0, mt: 0, ad: 0 },
  },
];
